import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import * as S from "./SwitchContent.Style";
import Text from "../Text";
import { Card } from "../Cards";

const LEFT = "left";
const RIGHT = "right";

const SwitchContent = ({
  leftButton,
  rightButton,
  leftId,
  rightId,
  leftContent,
  rightContent,
  contentActive,
  handleChange,
  noSwithDeskTop,
  className: propClassName,
}) => {
  const className = useMemo(() => {
    const disabledDesktopClass = noSwithDeskTop ? "disabled-lg" : null;
    return [propClassName, disabledDesktopClass].filter((x) => x).join(" ");
  }, [propClassName, noSwithDeskTop]);

  const isActiveContent = useCallback(
    (isActive) => (isActive ? "active" : null),
    []
  );

  const classNameConentLeft = useMemo(
    () =>
      [
        "SwitchContent SwitchContent__Left",
        isActiveContent(contentActive === leftId),
      ]
        .filter((x) => x)
        .join(" "),
    [contentActive, isActiveContent, leftId]
  );

  const classNameConentRight = useMemo(
    () =>
      [
        "SwitchContent SwitchContent__Right",
        isActiveContent(contentActive === rightId),
      ]
        .filter((x) => x)
        .join(" "),
    [contentActive, isActiveContent, rightId]
  );

  const onToggleHandle = useCallback(
    (evt, toggleContent) => {
      evt.preventDefault();

      if (handleChange) {
        handleChange(toggleContent);
      }
    },
    [handleChange]
  );

  const headerSwitch = (
    <S.ButtonsContainer>
      <S.SwitchButton
        variant="tertiary"
        onClick={(e) => onToggleHandle(e, leftId)}
      >
        {leftButton}
      </S.SwitchButton>
      <S.SwitchButton
        variant="tertiary"
        onClick={(e) => onToggleHandle(e, rightId)}
      >
        {rightButton}
      </S.SwitchButton>
      <S.ToggleButton
        isLeft={contentActive === leftId}
        buttonActive={contentActive}
      >
        <Text textSize="sm">
          {contentActive === leftId ? leftButton : rightButton}
        </Text>
      </S.ToggleButton>
    </S.ButtonsContainer>
  );

  return (
    <S.SwitchContainer as={Card} header={headerSwitch} className={className}>
      <S.SwitchContent className={classNameConentLeft}>
        {leftContent}
      </S.SwitchContent>
      <S.SwitchContent className={classNameConentRight}>
        {rightContent}
      </S.SwitchContent>
    </S.SwitchContainer>
  );
};

SwitchContent.defaultProps = {
  leftContent: null,
  rightContent: null,
  noSwithDeskTop: false,
  leftId: LEFT,
  rightId: RIGHT,
};

SwitchContent.propTypes = {
  leftButton: PropTypes.string.isRequired,
  rightButton: PropTypes.string.isRequired,
  leftContent: PropTypes.element,
  rightContent: PropTypes.element,
  contentActive: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  noSwithDeskTop: PropTypes.bool,
  leftId: PropTypes.string,
  rightId: PropTypes.string,
};

export default SwitchContent;
